const $doc = $(document)

$doc.on('click', '.js-btn-toggle', function (e) {
  e.preventDefault()

  const $this = $(this)
  const $target = $($this.data('target'))
  const className = $this.data('class')

  $target.toggleClass(className)
})
